// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col-code{min-width:170px}.col-fullName{width:20%}.col-phoneNumber{width:15%}.col-emailAddress{width:20%}.col-receivables{width:15%}.col-profit{width:20%}.col-action{min-width:120px}", ""]);
// Exports
module.exports = exports;
